var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("title"),_c('h1',[_vm._v("I am the header 1")]),_vm._t("text")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }